import { render, staticRenderFns } from "./LivestreamPostVideo.vue?vue&type=template&id=7dec0b00&scoped=true&"
import script from "./LivestreamPostVideo.vue?vue&type=script&lang=js&"
export * from "./LivestreamPostVideo.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamPostVideo.vue?vue&type=style&index=0&id=7dec0b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec0b00",
  null
  
)

export default component.exports